import { mapGetters, mapActions } from 'vuex'

const moduleName = 'glMapping'

export default {
  computed: {
    ...mapGetters(moduleName, {
      baseSnapshot: 'baseSnapshot',
      currentSnapshot: 'currentSnapshot',
      snapshotDiff: 'snapshotDiff'
    })
  },
  methods: {
    ...mapActions(moduleName, ['getStoreItem', 'saveSnapshot', 'clearSnapshots']),
    ...mapActions('printpreview', { addReportParameters: 'addParameters', addEmailer: 'addEmailer' })
  }
}
